import CtaController from './Controller/CtaController';

$(document).ready(function () {
  new CtaController();
});
